var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"voids"}},[_c('PageTitle',{attrs:{"title":_vm.$t('pos.voids'),"subtitle":_vm.$t('pos.voids_description')}}),_c('div',{staticClass:"container"},[_c('Panel',{attrs:{"showTitle":false}},[_c('Datatable',{attrs:{"entity":"sale_item_void","parameters":_vm.parameters}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }